import axios from 'axios';
import type { PMPhase } from '@/models/pmphase';

class PMPhaseWebservice {
    public load(withLessons: boolean = false) {
        return axios.get<PMPhase[]>('/pmphases', {
            params: {
                withLessons,
            },
        });
    }

    public getById(pmPhaseId: string) {
        return axios.get<PMPhase>('/pmphases/getById', {
            params: {
                pmPhaseId,
            },
        });
    }

    public store(pmPhase: PMPhase) {
        return axios.post('/pmphases/store', {
            title: pmPhase.title,
            description: pmPhase.description,
            order: pmPhase.order,
            abbreviation: pmPhase.abbreviation,
        });
    }

    public update(pmPhase: PMPhase) {
        return axios.post('/pmphases/update', {
            id: pmPhase.id,
            title: pmPhase.title,
            description: pmPhase.description,
            order: pmPhase.order,
            abbreviation: pmPhase.abbreviation,
        });
    }

    public remove(pmPhase: PMPhase) {
        return axios.post('/pmphases/remove', {
            id: pmPhase.id,
        });
    }
}

export const pmPhaseWebservice = new PMPhaseWebservice();
